import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["input", "submit"]

    trackedValues = {}
    currentValues = {}

    connect() {
        this.inputTargets.forEach( input => {
            this.trackedValues[input] = this.inputValue(input);
            this.currentValues[input] = this.inputValue(input);
        });
        this.disableSubmit();
    }

    change() {
        this.inputTargets.forEach(input => {
            this.currentValues[input] = this.inputValue(input);
        });
        this.disableSubmit();
    }


    disableSubmit() {
        if (JSON.stringify(this.trackedValues) === JSON.stringify(this.currentValues)) {
            this.submitTarget.setAttribute("disabled", "true");
            this.submitTarget.classList.add("disabled");
        } else {
            this.submitTarget.removeAttribute("disabled");
            this.submitTarget.classList.remove("disabled");
        }
    }

    inputValue(input) {
        if (input.type === "checkbox") {
            return input.checked
        } else {
            return input.value
        }
    }

}